// extracted by mini-css-extract-plugin
export default {"fill":"GlobalPageStyles_fill__9l5Qx","homeContainer":"GlobalPageStyles_homeContainer__1ynQv"};